import { CardProps } from 'components/molecules/Card';
import CardDetailTask from 'components/molecules/Card/Detail/Task';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
	actionCreators,
	getImages,
	getIsDone,
	getItemContentVideo,
	getItemRichText,
	getLink,
	getTitle,
} from 'store/programItems';

const mapStateToProps = (state: any, ownProps: any): CardProps & any /* FIXME: isDone */ => ({
	title: getTitle(state, ownProps.id),
	isDone: getIsDone(state, ownProps.id),
	richText: getItemRichText(state, ownProps.id),
	images: getImages(state, ownProps.id),
	contentVideo: getItemContentVideo(state, ownProps.id),
	link: getLink(state, ownProps.id),
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(actionCreators, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(CardDetailTask as any);
